export enum DesignationActionTypes {
    API_RESPONSE_SUCCESS = '@@designation/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@designation/API_RESPONSE_ERROR',

    ADD_DESIGNATION = '@@designation/ADD_DESIGNATION',
    EDIT_DESIGNATION = '@@designation/EDIT_DESIGNATION',
    GET_DESIGNATION = '@@designation/GET_DESIGNATION',
    GET_DESIGNATIONS = '@@designation/GET_DESIGNATIONS',
    RESET = '@@designation/RESET',
    RESET_SUCCESS = '@@designation/RESET_SUCCESS',
    RESET_ERROR = '@@designation/RESET_ERROR',
}
